import {LoginViewStore} from "../view-store";
import {MailOutlined, UserOutlined} from "@ant-design/icons";
import {ContentWrapper} from "../ui/ContentWrapper";
import {Flex, Input, Typography} from "antd";
import {FullFlex} from "../ui/FullFlex";
import React from "react";
import {useTranslation} from "react-i18next";
import {ForgotPasswordModalConfirm} from "../modals/ForgotPasswordModalConfirm";
import {Col} from "../ui/Col";
import {CentredTitle} from "../ui/CentredTitle";


const setPassword = (e) => {
    LoginViewStore.update(s => {
        s.password = e.target.value;
    });
}
export const AuthorizationStep = () => {
    const loginMethod = LoginViewStore.useState(s => s.loginMethod);
    const email = LoginViewStore.useState(s => s.email);
    const secureEmail = LoginViewStore.useState(s => s.secureEmail);
    const member = LoginViewStore.useState(s => s.member);
    const magicLink = LoginViewStore.useState(s => s.magicLink);
    const password = LoginViewStore.useState(s => s.password);
    const isCourse = LoginViewStore.useState(s => s.isCourse);
    const {t} = useTranslation(['login']);
    const inputProps = {
        size: 'large',
        disabled: true,
        placeholder: loginMethod === 'member' ? t(`member`) : t(`email`),
        value: loginMethod === 'member' ? member : email,
        prefix: loginMethod === 'member' ? <UserOutlined/> : <MailOutlined/>
    }

    return magicLink ? (<ContentWrapper>
            {/*   magic link sent to 2051020@gmail.com*/}
            <CentredTitle level={5}>{t('magicLinkTo')}</CentredTitle>
            <CentredTitle level={4}>{email || secureEmail}</CentredTitle>
        </ContentWrapper>)
        : (
            <ContentWrapper>
                <Typography.Title level={5}>{t('inputPassword')}</Typography.Title>
                {/*forgot password*/}
                <Input {...inputProps}/>
                <Col>
                    {!isCourse && (
                        <FullFlex justify={'end'}>
                            <ForgotPasswordModalConfirm/>
                        </FullFlex>
                    )}


                    <Input.Password value={password} onChange={setPassword} size="large" placeholder={t('password')}/>
                </Col>

            </ContentWrapper>
        )
};
